import React, { useState, useEffect } from 'react';
// import { appInsights, reactPlugin } from '../../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'clsx';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import Button from '@mui/material/Button';
import { gritComponentStyles } from '../../gritComponentStyles';
import CONSTANTS from '../../../../constants/constants';
import {
  ClaimList,
  ClaimTransformationList,
  ClaimTransformationComponent,
  ImpactAnalysisModalComponent,
} from '../../index';

import InputClaimComponent from './inputClaims';
import OutputClaimComponent from './outputClaims';
import PersistedClaimComponent from '../../persistedClaims';
import { TooltipComponent } from '../../../uiComponents';
import { deleteOperations, getOtherProfiles } from '../../../../store';
import MetadataGeneratorComponent from '../../metadataGenerator';

import { init_InputClaim, init_OutputClaim } from '../../../../xmlParsing/initInterfaces';
import { InputClaim } from '../../../../xmlParsing/interfaces';
import useTPHook from './../../useTPHook';
import { getTPType } from '../../../../utils/utils';

interface ComponentProps {
  parentTP: string;
  selectedTP: string;
  protocolName: string;
  closeTechnicalProfile: any;
  updateParent: any;
}

function AADVTPEditComponent({
  parentTP,
  protocolName,
  selectedTP,
  closeTechnicalProfile,
  updateParent,
}: ComponentProps) {
  const [type, setType] = useState<'Read' | 'Write' | ''>('Read');
  const dispatch = useDispatch();
  const otherProfiles = useSelector(getOtherProfiles);
  const classes = gritComponentStyles();
  const {
    actionData,
    rightData,
    claimsTransformationsList,
    validateTPData,
    show,
    setShow,
    setRightData,
    onChangeLabel,
    checkBeforeUpdate,
    repTechnicalProfile,
  } = useTPHook(protocolName, selectedTP, closeTechnicalProfile, parentTP, updateParent);

  useEffect(() => {
    if (otherProfiles.hasOwnProperty(selectedTP) && selectedTP) {
      const _obj = otherProfiles[selectedTP];
      if (_obj.hasOwnProperty(CONSTANTS.VALIDATION_METADATA) && _obj[CONSTANTS.VALIDATION_METADATA].length > 0) {
        setType(_obj[CONSTANTS.VALIDATION_METADATA][0][1]);
      }
    }
  }, [selectedTP, otherProfiles]);

  useEffect(() => {
    if (actionData && Object.keys(actionData).length > 0 && actionData[CONSTANTS.VALIDATION_METADATA].length > 0) {
      const _type = actionData[CONSTANTS.VALIDATION_METADATA].filter((el: [string, string]) => el[0] === 'Operation');
      _type.length > 0 && _type[0].length == 2 ? setType(_type[0][1]) : setType('');
    }
  }, [actionData]);

  return (
    <>
      <div className={cn(classes.popup, classes.validationPopup)}>
        <div className={cn(classes.header)}>
          <div className={cn(classes.flexRow, classes.alignCenter)}>
            <div className={classes.actionName}>Label</div>
            <div>
              {actionData && (
                <input
                  className={classes.input}
                  type="text"
                  onChange={onChangeLabel}
                  value={actionData['displayName'] || ''}
                />
              )}
            </div>
            <div>
              {actionData && getTPType(actionData.protocol, actionData.metadata) + ' (' + actionData['id'] + ') '}
              <TooltipComponent
                title={CONSTANTS.HELPTEXT.AADValidationTP.header}
                desc={CONSTANTS.HELPTEXT.AADValidationTP.description}
                link={CONSTANTS.HELPTEXT.AADValidationTP.link}
              />
            </div>
          </div>
          <div>
            <ClearOutlinedIcon onClick={() => closeTechnicalProfile({ ...actionData })} className={classes.delete} />
          </div>
        </div>

        <div className={cn(classes.flexRow, classes.policyBody)}>
          {!!actionData && (
            <div className={classes.showPolicy}>
              <Button
                variant="contained"
                onClick={() => {
                  setRightData({
                    type: CONSTANTS.VALIDATION_METADATA,
                    mode: 'edit',
                    list: [],
                    data: actionData[CONSTANTS.VALIDATION_METADATA],
                  });
                }}
              >
                View / Edit Metadata&nbsp;&nbsp;
                <TooltipComponent
                  title={CONSTANTS.HELPTEXT.Metadata.header}
                  desc={CONSTANTS.HELPTEXT.Metadata.description}
                  link={CONSTANTS.HELPTEXT.Metadata.link}
                />
              </Button>

              <div className={classes.heading}>
                Input Claims&nbsp;&nbsp;
                <TooltipComponent
                  title={CONSTANTS.HELPTEXT.InputClaims.header}
                  desc={CONSTANTS.HELPTEXT.InputClaims.description}
                  link={CONSTANTS.HELPTEXT.InputClaims.link}
                />
              </div>
              <ClaimList
                list={actionData[CONSTANTS.INPUT_CLAIMS]}
                onEditHandler={(val: string) => {
                  setRightData({
                    type: CONSTANTS.INPUT_CLAIMS,
                    id: val,
                    mode: 'edit',
                    list: [],
                    data: actionData[CONSTANTS.INPUT_CLAIMS].filter(
                      (el: InputClaim) => el.claimTypeReferenceId === val,
                    )[0],
                  });
                }}
                onDeleteHandler={(val: string) => {
                  dispatch(
                    deleteOperations({
                      type: CONSTANTS.INPUT_CLAIMS,
                      protocolName,
                      selectedTP: actionData['id'],
                      id: val,
                    }),
                  );
                  Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                }}
              />

              <Button
                variant="contained"
                onClick={() => {
                  setRightData({
                    type: CONSTANTS.INPUT_CLAIMS,
                    mode: 'add',
                    list: actionData[CONSTANTS.INPUT_CLAIMS],
                    data: init_InputClaim(),
                  });
                }}
              >
                Add INPUT CLAIMS
              </Button>
              {type === 'Write' && (
                <>
                  <div className={classes.heading}>
                    Persisted Claims&nbsp;&nbsp;
                    <TooltipComponent
                      title={CONSTANTS.HELPTEXT.PersistedClaims.header}
                      desc={CONSTANTS.HELPTEXT.PersistedClaims.description}
                      link={CONSTANTS.HELPTEXT.PersistedClaims.link}
                    />
                  </div>
                  <ClaimList
                    list={actionData[CONSTANTS.PERSISTED_CLAIMS]}
                    onEditHandler={(val: string) => {
                      setRightData({
                        type: CONSTANTS.PERSISTED_CLAIMS,
                        id: val,
                        mode: 'edit',
                        list: [],
                        data: (actionData[CONSTANTS.PERSISTED_CLAIMS] || []).filter(
                          (el: InputClaim) => el.claimTypeReferenceId === val,
                        )[0],
                      });
                    }}
                    onDeleteHandler={(val: string) => {
                      dispatch(
                        deleteOperations({
                          type: CONSTANTS.PERSISTED_CLAIMS,
                          protocolName,
                          selectedTP: actionData['id'],
                          id: val,
                        }),
                      );
                      Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      setRightData({
                        type: CONSTANTS.PERSISTED_CLAIMS,
                        mode: 'add',
                        data: init_OutputClaim(),
                        list: actionData[CONSTANTS.PERSISTED_CLAIMS],
                      });
                    }}
                  >
                    Add PERSISTED CLAIMS
                  </Button>
                </>
              )}
              <div className={classes.heading}>
                Output Claims&nbsp;&nbsp;
                <TooltipComponent
                  title={CONSTANTS.HELPTEXT.OutputClaims.header}
                  desc={CONSTANTS.HELPTEXT.OutputClaims.description}
                  link={CONSTANTS.HELPTEXT.OutputClaims.link}
                />
              </div>
              <ClaimList
                list={actionData[CONSTANTS.OUTPUT_CLAIMS]}
                onEditHandler={(val: string) => {
                  setRightData({
                    type: CONSTANTS.OUTPUT_CLAIMS,
                    id: val,
                    mode: 'edit',
                    list: [],
                    data: actionData[CONSTANTS.OUTPUT_CLAIMS].filter(
                      (el: InputClaim) => el.claimTypeReferenceId === val,
                    )[0],
                  });
                }}
                onDeleteHandler={(val: string) => {
                  dispatch(
                    deleteOperations({
                      type: CONSTANTS.OUTPUT_CLAIMS,
                      protocolName,
                      selectedTP: actionData['id'],
                      id: val,
                    }),
                  );
                  Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                }}
              />
              <Button
                variant="contained"
                onClick={() => {
                  setRightData({
                    type: CONSTANTS.OUTPUT_CLAIMS,
                    mode: 'add',
                    data: init_OutputClaim(),
                    list: actionData[CONSTANTS.OUTPUT_CLAIMS],
                  });
                }}
              >
                Add OUTPUT CLAIMS
              </Button>

              <div className={classes.heading}>
                Output Claim Transformation&nbsp;&nbsp;
                <TooltipComponent
                  title={CONSTANTS.HELPTEXT.OutputClaimsTransformations.header}
                  desc={CONSTANTS.HELPTEXT.OutputClaimsTransformations.description}
                  link={CONSTANTS.HELPTEXT.OutputClaimsTransformations.link}
                />
              </div>

              <ClaimTransformationList
                list={(actionData[CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS] || []).filter((el: string) =>
                  claimsTransformationsList.hasOwnProperty(el),
                )}
                onEditHandler={(val: string) => {
                  setRightData({
                    type: CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS,
                    id: val,
                    mode: 'edit',
                    data: claimsTransformationsList[val],
                  });
                }}
                onDeleteHandler={(val: string) => {
                  dispatch(
                    deleteOperations({
                      type: CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS,
                      protocolName,
                      selectedTP: actionData['id'],
                      id: val,
                    }),
                  );
                  Object.keys(rightData).length > 0 && rightData['id'] === val && setRightData({});
                }}
              />

              <Button
                variant="contained"
                onClick={() => {
                  setRightData({
                    type: CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS,
                    mode: 'add',
                    list: actionData[CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS],
                    data: actionData[CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS].filter((el: string) =>
                      claimsTransformationsList.hasOwnProperty(el),
                    ),
                  });
                }}
              >
                Add OUTPUT CLAIMS TRANSFORMATION
              </Button>
            </div>
          )}

          {rightData && (
            <div className={classes.editPolicy}>
              {[CONSTANTS.VALIDATION_METADATA].includes(rightData['type']) && (
                <MetadataGeneratorComponent
                  metadata={CONSTANTS.getMetaData('AAD-' + type)}
                  data={rightData?.data}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
              {[CONSTANTS.INPUT_CLAIMS].includes(rightData['type']) && (
                <InputClaimComponent
                  data={rightData?.data}
                  list={rightData?.list}
                  mode={rightData?.mode}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
              {[CONSTANTS.PERSISTED_CLAIMS].includes(rightData['type']) && (
                <PersistedClaimComponent
                  data={rightData?.data}
                  list={rightData?.list}
                  mode={rightData?.mode}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
              {[CONSTANTS.OUTPUT_CLAIMS].includes(rightData['type']) && (
                <OutputClaimComponent
                  data={rightData?.data}
                  list={rightData?.list}
                  mode={rightData?.mode}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
              {[CONSTANTS.OUTPUT_CLAIMS_TRANSFORMATIONS].includes(rightData['type']) && (
                <ClaimTransformationComponent
                  data={rightData?.data}
                  list={rightData?.list}
                  mode={rightData?.mode}
                  changeHandler={(data: any) => checkBeforeUpdate(data, rightData['type'], rightData['mode'])}
                />
              )}
            </div>
          )}
          {show === 'validateTP' && (
            <ImpactAnalysisModalComponent
              data={validateTPData['validateData']}
              currentTP={actionData['id']}
              parentTP={parentTP}
              close={(tpName: string) => {
                repTechnicalProfile(tpName);
                setShow('');
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}

// export default withAITracking(reactPlugin, AADVTPEditComponent);
export default AADVTPEditComponent;
